module.exports = __webpack_public_path__ + "static/media/viewAuditTrailGuide3_Jap.cb7b7583.png";